/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { THealthCheckResponse } from '../models/THealthCheckResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HealthCheckService {
    /**
     * Health Check
     * @returns THealthCheckResponse Ok
     * @throws ApiError
     */
    public static healthCheck(): CancelablePromise<THealthCheckResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/healthz',
        });
    }
}
